<template>
  <InputWrapper
    v-slot="{ inputId }"
    :input-id="id"
    :label="t('lineItems.weight')"
    class="order-weight-filter"
    optional
  >
    <WeightFilter :id="inputId" v-model="modelValue.weight" append-to="body" />
  </InputWrapper>
</template>

<script lang="ts" setup>
import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { OrderSearchCriteria } from '@/model';

import WeightFilter from '@/components/search/WeightFilter.vue';
import InputWrapper from '@rygen/rygen-ui/components/form/InputWrapper.vue';

const modelValue = defineModel({
  type: OrderSearchCriteria,
  default: () => new OrderSearchCriteria(),
});

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
});
const { id } = toRefs(props);

const { t } = useI18n();
</script>
